import { Link } from "react-router-dom";
import { useCallback } from "react";
import Avatar from "@/Components/Avatar/Avatar";
import { UserAvatar } from "@/Components/Avatar/UserAvatar";
import { AgentAvatar } from "@/Components/Avatar/AgentAvatar";
import { useCache } from "@/Hooks/useCache";
import { useAutoRefreshGet } from "@/Hooks/useAutoRefreshList";
import api from "@/Api/Api";
import { datetimeToWhenString } from "@shared/Helpers/DateFunctions";
import { FeedItem } from "@shared/Entities/EntityTypes";
import { removeAllHtml } from "@shared/Helpers/HtmlFunctions";

export default function Feed() {
	const { data, doingFirstLoad, errorMsg, successful } = useAutoRefreshGet(
		useCallback(() => api.BasicGet<FeedItem[]>("/feed"), []),
		60
	);

	if (doingFirstLoad) {
		// TODO: Needs a pretty loading state.
	}

	if (!successful || data == null) {
		// TODO: Could have a generic error box to use.
		return (
			<div>
				Could not load feed.
				{errorMsg}
			</div>
		);
	} else {
		return (
			data.map((feedItem) => (
				<FeedItemViewer key={String(feedItem.ticketId) + feedItem.id} feedItem={feedItem} />
			))
		);
	}
}

interface FeedItemProps {
	feedItem: FeedItem;
}

function FeedItemViewer(props: FeedItemProps) {
	const cache = useCache();

	const user = cache.getUser(props.feedItem.userId);
	const agent = cache.getAgent(props.feedItem.agentId);

	const noHtmlNote = removeAllHtml(props.feedItem.noteBody?.trim());

	let feedAvatar;

	if (user != null) {
		feedAvatar = <Link to={"/users/" + props.feedItem.userId}>
			<UserAvatar user={user} widthPx={30} />
		</Link>;
	} else if (agent != null) {
		feedAvatar = <Link to={"/config/manage/agents/" + props.feedItem.agentId}>
			<AgentAvatar agent={agent} widthPx={30} />
		</Link>;
	} else {
		feedAvatar = <Avatar widthPx={30} avatarHashString={"System_" + props.feedItem.id} />;
	}

	return (
		<div className="flex p-2 border rounded border-gray-300 bg-white mb-2 shadow-sm break-all">
			<div className="mr-2">
				{feedAvatar}
			</div>
			<Link to={"/tickets/" + props.feedItem.ticketId}>
				<div>
					<div className="font-semibold line-clamp-1">
						# {props.feedItem.ticketId} - {props.feedItem.description}
					</div>
					<div className="my-2 line-clamp-2">
						{noHtmlNote}
					</div>
					<div className="text-gray-500">{datetimeToWhenString(props.feedItem.customCreated)}</div>
				</div>
			</Link>
		</div>
	);
}
